const flashBannerNew = `
  flashBannerItem {
    ...on FlashBannerItemWithOffer {
      bannerName
      messageDesktop
      messageMobile
      backgroundColor
      contentColor
      discount
      discountLabel
      linkTextDesktop
      linkUrl
    }
  }
`

const badgeFields = `
  {
      title
      badgeType
      themeColour
      small
      iconName
  }
`

const imageFields = `
  {
      title
      url
  }
`

export { badgeFields, flashBannerNew, imageFields }
